'use client';

import { useAppContext } from '../context/AppContext';

export function useSidebar() {
  const { sidebarCollapsed, setSidebarCollapsed } = useAppContext();

  const toggle = () => setSidebarCollapsed(!sidebarCollapsed);
  const collapse = () => setSidebarCollapsed(true);
  const expand = () => setSidebarCollapsed(false);

  return { collapsed: sidebarCollapsed, toggle, collapse, expand };
}
